import { Fragment, createElement, Children } from 'react';
import toReact from 'rehype-react';
import parse from 'remark-parse';
import toHtml from 'remark-rehype';
import { unified } from 'unified';
import { UnorderedList, OrderedList, ListItem, Paragraph, Strong } from './styled';
const componentMapping = {
    ul: UnorderedList,
    ol: OrderedList,
    li: ListItem,
    p: Paragraph,
    strong: Strong,
};
const mapChildren = (children) => Children.map(children, child => {
    if (child.type === Fragment) {
        return mapChildren(child.props.children);
    }
    return child;
});
export function stringToReact(content) {
    if (content) {
        const { result } = unified()
            .use(parse)
            .use(toHtml)
            .use(toReact, { Fragment, createElement, components: componentMapping })
            .processSync(content);
        return mapChildren(result);
    }
    return undefined;
}
